import { addItemToCollection } from "directus/src/operations";

export async function createTag({ item }) {
  try {
    const data = await addItemToCollection("tags", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
